import React, { useEffect } from 'react'
import { AppRouter } from './routers/AppRouter'
import { DevicesProvider } from '@gojiraf/responsive'
import { ThemeProvider } from '@material-ui/core/styles'
import CssBaseline from '@material-ui/core/CssBaseline'
import { GlobalStyle } from './app/styles/globalStyles'
import theme from './theme'
import './app/styles/globals.css'
import { usePostHogAnalytics } from '@gojiraf/analytics'
import { useAuth } from '@gojiraf/auth'
import { v4 } from 'uuid'
import { ProductTour } from './app/components/ProductTour/ProductTour'

const App = () => {
  const { initPostHog } = usePostHogAnalytics()
  const { setCreds, user } = useAuth()

  useEffect(() => {
    let currentUserId = user.id
    if (!currentUserId) {
      currentUserId = v4()
      setCreds({ id: currentUserId })
    }
    initPostHog()

    if (window.self !== window.top) {
      sessionStorage.setItem('inIframe', 'true')
    }
    document.addEventListener('gesturestart', (e) => {
      e.preventDefault()
    })
  }, [])

  return (
    <DevicesProvider>
      <GlobalStyle />
      <ThemeProvider theme={theme()}>
        <CssBaseline />
        <ProductTour>
          <AppRouter />
        </ProductTour>
      </ThemeProvider>
    </DevicesProvider>
  )
}

export { App }
